import React from "react"

const NoHistory = () => (
  <h3 className="text-center no-border no-p-t">
    Your parcel is awaiting processing. Please check back shortly for further updates.
  </h3>
)

export default NoHistory



// WEBPACK FOOTER //
// ./src/views/Parcel/components/History/NoHistory/NoHistory.js